const messages = {
  message: {
    name: 'Nome',
    surName: 'Cognome',
    mobile: 'Cellulare',
    email: 'Indirizzo email',
    company: 'Ragione sociale',
    cif: 'P.IVA',
    profile: 'Profilo',
    phone: 'Telefono',
    country: 'Paese',
    location: 'Provincia',
    address: 'Indirizzo',
    city: 'Città',
    cp: 'CAP',
    web: 'Sito internet',
    comment: 'Osservazioni',
    terms: {
      wp: 'Ho letto e accetto <a href="/politica-privacidad">l\'informativa sulla privacy</a> e le <a href="http://myzone.airzone.es/terms-use">condizioni d\'uso</a>.',
      myzone: 'Ho letto e accetto <a href="/privacy-policy">l\'informativa sulla privacy</a> e le <a href="/terms-use">condizioni d\'uso</a>.',
    },
    infoComercial: 'Vorrei ricevere informazioni commerciali Airzone',
    formsError: {
      terms: 'Devi accettare i termini e le condizioni.',
      front: 'Non è stato possibile inviare il modulo a causa dei seguenti problemi.',
      server: 'Non è stato possibile inviare il modulo. Per favore riprova più tardi.',
    },
    formsSuccess: {
      AirzoneSIM: 'Ti sei registrato correttamente.  A breve riceverà una mail con lo strumento.',
      Myzone: 'La sua richiesta è stata registrata e sarà gestita il prima possibile.',
    },
    personalData: 'I tuoi dati personali',
    companyData: 'I dati della tua azienda',
    submit: 'Inviare',
    selectSim: {
      label: '¿Como conoció Airzone SIM?',
      options: {
        'Técnico/Comercial/Prescriptor': 'Técnico / Comercial / Prescriptor',
        'Distribuidor/Oficial/ATD': 'Distribuidor / Oficial / ATD',
        'Promotora/Constructora': 'Promotora / Constructora',
        'Arquitecto/Ingeniería': 'Arquitecto / Ingeniería',
        Instalador: 'Instalador',
        'RRSS/Medios': 'Redes sociales / Medios',
        'Cursos-Formacion': 'Cursos de Formación',
      },
    },
  },
};

export default messages;
